import type { FC } from "react";
import { twMerge } from "tailwind-merge";

import { BlockVariantType } from "../../../../../../../collaboration/src/shared/types/worksheet";

import { t } from "i18n/i18n";
import { IconText } from "mds/components/IconText";
import { PresentPlayOutlineIcon } from "mds/icons";
import { FeatureStatus } from "utils/presentation";

type FeatureHeaderProps = {
  isPresenting: boolean;
  featureStatus: FeatureStatus | null;
  responseName?: string | null;
  blockType?: BlockVariantType | null;
  anonymizeResponses: boolean;

  className?: string;
};

const getHeaderText = ({
  featureStatus,
  isPresenting,
  responseName,
  blockType,
  anonymizeResponses,
}: FeatureHeaderProps): string => {
  if (featureStatus) {
    switch (featureStatus) {
      case FeatureStatus.CLASS_RESPONSES:
        return isPresenting
          ? t("presentation.featuring.class_responses")
          : t("presentation.featuring.status.class_responses");

      case FeatureStatus.PARTICIPANT_RESPONSE:
        return isPresenting
          ? anonymizeResponses
            ? t("presentation.featuring.anonymous_student_responses")
            : t("presentation.featuring.student_responses", {
                name: responseName || t("presentation.featuring.unknown_user"),
              })
          : t("presentation.featuring.status.participant_response");

      case FeatureStatus.OUTCOME:
        return t("presentation.featuring.status.outcome");

      case FeatureStatus.BLOCK:
        return t(`presentation.featuring.blocks.${blockType || "Asset"}`);

      default:
        return t(`presentation.featuring.status.${featureStatus}`);
    }
  }

  return "";
};

export const FeatureSimpleHeader: FC<FeatureHeaderProps> = ({ className, ...props }) => {
  const headerText = getHeaderText(props);

  return (
    <IconText
      className={twMerge("gap-4 font-medium", className)}
      iconStart={<PresentPlayOutlineIcon className="text-green" />}
      text={headerText}
    />
  );
};
